import { useEffect, useRef } from "react";

/* Selettori di elementi focusabili dentro un contenitore. */
const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

/* Trappola del focus per i pannelli modali (menu mobile, preventivo, banner cookie):
   con il pannello aperto Tab e Shift+Tab restano al suo interno, Esc chiama onEsc. */
export function useDialogA11y(ref, active, onEsc) {
  useEffect(() => {
    if (!active || !ref.current) return undefined;
    const node = ref.current;
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        if (onEsc) onEsc();
        return;
      }
      if (e.key !== "Tab") return;
      const items = [...node.querySelectorAll(FOCUSABLE)].filter(
        (el) => el.getClientRects().length > 0
      );
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !node.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !node.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    };
    node.addEventListener("keydown", onKey);
    return () => node.removeEventListener("keydown", onKey);
  }, [ref, active, onEsc]);
}

/* Alla chiusura di un pannello il focus torna al pulsante che lo ha aperto. */
export function useFocusReturn(active) {
  const saved = useRef(null);
  useEffect(() => {
    if (!active) return undefined;
    saved.current = document.activeElement;
    return () => {
      const el = saved.current;
      if (el && el.focus) el.focus();
      saved.current = null;
    };
  }, [active]);
}
